module.exports = __webpack_public_path__ + "static/media/window-alt.51a0ad90.svg";